module.exports = __webpack_public_path__ + "static/media/ltu_2x.614cddce.png";